import React from 'react';
import './Loader9Dots.css';


const Loader9Dots = () => {
  return (
        <div className='loader-9-dots'></div>
    );
};

export default Loader9Dots;
